<template>
  <div :class="$style.questionsContainer">
    <img src="@/assets/img/ic_question_big.png" alt="Help">
    <p :class="$style.questions">
      Questions? Feel free to
      <a href="mailto:info@eztx.com?subject=eztx.com question" :class="$style.link">
        contact us</a>!
    </p>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" module>
.questionsContainer {
  position: absolute;
  top: 20px;
  right: 30px;
  display: flex;
  align-items: center;

  img {
    max-width: 58px;
  }
}

.questions {
  font-size: 1.5rem;
  font-weight: 700;
  margin-left: 12px;
  margin-bottom: 0;

  a.link {
    color: inherit;
  }
}
</style>
